import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { usePageContent } from '../../hooks/usePageContent';
import './index.module.css';

const Wizard = ({
  steps = [],
  currentStep = 0,
  onStepClick,
  backLink,
  backLabel = 'Go to previous page',
  isDisabled = false,
  dark = true
}) => {
  const { find } = usePageContent('wizard');
  const c = find('wizard') || {};

  const totalSteps = steps.length;

  return (
    <div className={`plate-wizard__progress${dark ? ' plate-wizard__progress--dark' : ''}`}>
      <h2 className="visuallyhidden">{c.stepsHeading || 'Steps to create a plate'}</h2>
      {backLink && (
        <Link className="plate-wizard__progress-back" to={backLink}>
          <span className="visuallyhidden">{backLabel}</span>
        </Link>
      )}
      <ol className="plate-wizard__progress-list">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isComplete = index < currentStep;
          const isCurrent = index === currentStep;
          const stepDisabled = (isDisabled && isComplete) || step.isDisabled;
          const itemClass = [
            'plate-wizard__progress-item',
            stepDisabled && 'plate-wizard__progress-item--disabled',
            isComplete && 'plate-wizard__progress-item--complete',
            isCurrent && 'plate-wizard__progress-item--current'
          ].filter(Boolean).join(' ');

          const handleClick = () => {
            if (onStepClick && (isComplete || isCurrent) && !stepDisabled) {
              onStepClick(index);
            }
          };

          const stepLabel = (
            <span className="plate-wizard__progress-label">
              {c.stepPrefix || 'Step'} {stepNumber} {c.stepOf || 'of'} {totalSteps}:{' '}
            </span>
          );

          const stepHref = step.href || step.link;

          return (
            <li key={index} className={itemClass}>
              {stepHref && isComplete && !stepDisabled ? (
                <Link
                  to={stepHref}
                  className="plate-wizard__progress-link"
                  onClick={handleClick}
                >
                  {stepLabel}
                  {step.title}
                </Link>
              ) : (
                <span className="plate-wizard__progress-link">
                  {stepLabel}
                  {step.title}
                  {isCurrent && <span className="visuallyhidden"> {c.currentText || '(Current)'}</span>}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

Wizard.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string,
      isDisabled: PropTypes.bool
    })
  ).isRequired,
  currentStep: PropTypes.number,
  onStepClick: PropTypes.func,
  backLink: PropTypes.string,
  backLabel: PropTypes.string,
  isDisabled: PropTypes.bool,
  dark: PropTypes.bool
};

export default Wizard;
